
// checks if the given object is a date
export function isValidDate(date: Object | null | undefined): date is Date {
    return date instanceof Date && !isNaN(date.valueOf())
}
